export default {
  "content": "<path d=\"M3.5 19h17v-2.5h2V20a1 1 0 01-1 1h-19a1 1 0 01-1-1v-3.5h2V19z\" fill=\"#7B61FF\"/><path d=\"M17.322 3.07L13.91 8H17v2h-4v2h4v2h-4v3h-2v-3H7v-2h4v-2H7V8h3.09L6.679 3.07l1.644-1.14L12 7.243l3.678-5.311 1.644 1.138z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};